import { ModulPrAuspFilter } from "./modul-pr-ausp-filter.model";
import { ModulPrWertFilter } from "./modul-pr-wert-filter.model";

export class ModulAuspraegungPrFilter {

    modulPrAuspFilterList: ModulPrAuspFilter[] = [];
    modulPrWertFilterList: ModulPrWertFilter[] = [];       
 
    snr! : number;
   }
 

   